import '../../styles/SingleTile.css'; // Import the CSS file for styling

const SingleTile = ({ name, value }) => {
  return (
    <div className="single-tile">
      <div className="tile-header">{name}</div>
      <div className="tile-content">{value}</div>
    </div>
  );
};

export default SingleTile;